// extracted by mini-css-extract-plugin
export default {"currency":"Currency--currency--3efce8"};